<div appChart [data]="chartData" [options]="chartOptions"></div>
